import { render, staticRenderFns } from "./bindWeChat.vue?vue&type=template&id=4ba3ddbd&scoped=true"
import script from "./bindWeChat.vue?vue&type=script&lang=js"
export * from "./bindWeChat.vue?vue&type=script&lang=js"
import style0 from "./bindWeChat.vue?vue&type=style&index=0&id=4ba3ddbd&prod&lang=css"
import style1 from "./bindWeChat.vue?vue&type=style&index=1&id=4ba3ddbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba3ddbd",
  null
  
)

export default component.exports